import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ExecutiveDashboard } from './models';

export interface LoadingStatus {
    serverRequestInProgress: boolean;
    loaded: boolean;
}

export interface State extends EntityState<ExecutiveDashboard>, LoadingStatus {}

export const adapter: EntityAdapter<ExecutiveDashboard> = createEntityAdapter<ExecutiveDashboard>();

export const initialState: State = adapter.getInitialState({
    serverRequestInProgress: false,
    loaded: false,
});
